import {ref} from 'vue';

export default function (popupStatus = false){
	const popupActive = ref(popupStatus);
	function popupOpen(){
		popupActive.value = !popupActive.value;
	}
	function popupClose(){
		popupActive.value = false;
	}
	
	return { popupActive, popupOpen, popupClose}
}
